import { render } from "./AddObjectStorage.vue?vue&type=template&id=45509221&scoped=true"
import script from "./AddObjectStorage.vue?vue&type=script&lang=js"
export * from "./AddObjectStorage.vue?vue&type=script&lang=js"

import "./AddObjectStorage.vue?vue&type=style&index=0&id=45509221&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45509221"]])

export default __exports__